import PropTypes from "prop-types";

export const ContainerType = {
	children: PropTypes.node.isRequired,
	container: PropTypes.string
};
